export default __webpack_public_path__ + "static/media/2398.b92bcd96.png";